import { ICreateContaReceberUseCase } from "../../../presentation/useCases/create/create_conta_receber_use_case";
import { ContaReceber } from "../../models/conta_receber";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CreateContaReceberUseCase
 */

export class CreateContaReceberUseCase implements ICreateContaReceberUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async createContaReceber(form: ContaReceber): Promise<number> {
    const result = await this.repository.createContaReceber(form);
    return result;

  }
}
